var EventRunnerAbstract = function () {
  function EventRunnerAbstract(emitter, handler) {
    this.emitter = emitter;
    this.handler = handler;
  }

  EventRunnerAbstract.prototype.getHandler = function () {
    return this.handler;
  };

  return EventRunnerAbstract;
}();

export default EventRunnerAbstract;